(function () {
  const ICONS = {
    details: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 3H4C2.897 3 2 3.897 2 5V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3ZM4 19V5H20L20.002 19H4Z" fill="#111111"/><path d="M6 7H18V9H6V7ZM6 11H18V13H6V11ZM6 15H12V17H6V15Z" fill="#111111"/></svg>',
    formula: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21.8798 2.15039L20.6798 2.55039C18.6232 3.26494 16.427 3.48421 14.2698 3.19039C12.0029 2.8386 9.68267 3.15121 7.58975 4.09039C6.48023 4.56284 5.50651 5.30531 4.75723 6.2502C4.00795 7.19509 3.50692 8.3124 3.29975 9.50039C3.08902 10.6428 3.11058 11.816 3.36314 12.95C3.6157 14.0839 4.09408 15.1554 4.76975 16.1004C4.70975 16.3104 4.64975 16.5204 4.59975 16.7304C4.19359 18.4574 3.99221 20.2263 3.99975 22.0004H5.99975C6.09375 20.5482 6.29092 19.1046 6.58975 17.6804C7.97719 18.4296 9.5331 18.8117 11.1098 18.7904C12.5802 18.7894 14.0356 18.4936 15.3898 17.9204C22.9998 14.6704 21.9998 3.86039 21.9998 3.41039L21.8798 2.15039ZM14.6098 16.0804C11.9998 17.1904 8.87975 17.0004 7.12975 15.6304C7.42552 14.6414 7.8314 13.6888 8.33975 12.7904C8.73495 12.1438 9.20118 11.5434 9.72975 11.0004C10.2699 10.4516 10.8782 9.97435 11.5398 9.58039C12.9068 8.76294 14.423 8.22584 15.9998 8.00039V7.00039C14.1855 6.93759 12.3824 7.3078 10.7398 8.08039C9.06017 8.89994 7.63578 10.1618 6.61975 11.7304C6.24292 12.3295 5.90876 12.9543 5.61975 13.6004C5.15627 12.4147 5.02489 11.1251 5.23975 9.87039C5.38053 8.99192 5.74265 8.16377 6.292 7.46396C6.84135 6.76415 7.55984 6.21573 8.37975 5.87039C9.57537 5.31155 10.88 5.02467 12.1998 5.03039C12.8198 5.03039 13.4298 5.09039 14.0698 5.14039C16.0741 5.39899 18.1091 5.28028 20.0698 4.79039C19.9998 7.55039 19.4998 14.0004 14.6098 16.0804Z" fill="#111111"/></svg>',
    expect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.2399 15.0139C19.4127 14.8441 19.6161 14.7592 19.8501 14.7592C20.0841 14.7592 20.2875 14.8441 20.4601 15.0139L21.9874 16.5662C22.1572 16.7368 22.2421 16.9359 22.2421 17.1634C22.2421 17.3909 22.157 17.5907 21.9869 17.7627C21.8167 17.9345 21.6171 18.0204 21.3881 18.0204C21.1593 18.0204 20.9592 17.9335 20.7879 17.7597L19.2416 16.2324C19.0678 16.0611 18.9809 15.8577 18.9809 15.6222C18.9809 15.3867 19.0672 15.1839 19.2399 15.0139ZM19.8976 3.09491C20.0676 3.26691 20.1526 3.47033 20.1526 3.70516C20.1526 3.94 20.0676 4.14166 19.8976 4.31016L18.3704 5.84341C18.1967 6.01325 17.9929 6.09816 17.7589 6.09816C17.5247 6.09816 17.3224 6.01275 17.1519 5.84191C16.978 5.66958 16.8911 5.46583 16.8911 5.23066C16.8911 4.99533 16.978 4.79341 17.1519 4.62491L18.6981 3.09166C18.87 2.92183 19.0703 2.83691 19.2991 2.83691C19.5281 2.83691 19.7276 2.92291 19.8976 3.09491ZM4.10538 3.09466C4.27621 2.92283 4.47921 2.83691 4.71438 2.83691C4.94971 2.83691 5.15246 2.92183 5.32262 3.09166L6.85588 4.64391C7.02571 4.81558 7.11063 5.01591 7.11063 5.24491C7.11063 5.47391 7.02638 5.67341 6.85788 5.84341C6.68921 6.01325 6.48996 6.09816 6.26013 6.09816C6.03013 6.09816 5.83088 6.01325 5.66238 5.84341L4.10413 4.31016C3.93413 4.14 3.84912 3.93783 3.84912 3.70366C3.84912 3.46966 3.93454 3.26666 4.10538 3.09466ZM4.76613 15.0154C4.93596 15.1861 5.02088 15.3891 5.02088 15.6244C5.02088 15.8596 4.93596 16.0622 4.76613 16.2324L3.23888 17.7597C3.06754 17.9335 2.86413 18.0204 2.62863 18.0204C2.39313 18.0204 2.19038 17.9358 2.02038 17.7667C1.85054 17.5973 1.76562 17.3981 1.76562 17.1689C1.76562 16.9397 1.85054 16.7388 2.02038 16.5662L3.57263 15.0139C3.74329 14.8441 3.94237 14.7592 4.16987 14.7592C4.39738 14.7592 4.59613 14.8446 4.76613 15.0154ZM8.30513 17.5879L12.0019 15.3679L15.7046 17.6134L14.7144 13.4204L17.9791 10.5759L13.6809 10.1997L12.0009 6.23291L10.3286 10.1744L6.02863 10.5569L9.29588 13.3972L8.30513 17.5879ZM12.0009 17.3592L7.47038 20.0934C7.31721 20.1926 7.15471 20.2343 6.98288 20.2187C6.81121 20.203 6.65987 20.1496 6.52887 20.0584C6.39804 19.9674 6.29954 19.8458 6.23338 19.6937C6.16721 19.5417 6.15471 19.3703 6.19588 19.1797L7.39112 14.0172L3.38662 10.5199C3.23746 10.3911 3.14738 10.2455 3.11638 10.0832C3.08538 9.92083 3.08854 9.7635 3.12588 9.61116C3.16321 9.45866 3.24921 9.32966 3.38388 9.22416C3.51838 9.1185 3.68096 9.05733 3.87163 9.04066L9.16087 8.57516L11.2051 3.69716C11.2756 3.52316 11.3855 3.39375 11.5346 3.30891C11.6838 3.22391 11.8371 3.18141 11.9946 3.18141C12.1521 3.18141 12.3071 3.22391 12.4596 3.30891C12.6121 3.39375 12.7245 3.52316 12.7966 3.69716L14.8454 8.57766L20.1361 9.04066C20.3228 9.05733 20.4834 9.1185 20.6179 9.22416C20.7525 9.32966 20.8385 9.45866 20.8759 9.61116C20.9132 9.7635 20.9174 9.92091 20.8884 10.0834C20.8594 10.2459 20.7702 10.3914 20.6209 10.5199L16.6166 14.0172L17.8116 19.1857C17.849 19.3723 17.8332 19.5412 17.7644 19.6922C17.6955 19.8432 17.5992 19.969 17.4754 20.0697C17.3467 20.1592 17.1965 20.2103 17.0246 20.2232C16.853 20.2358 16.6905 20.1946 16.5374 20.0994L12.0009 17.3592Z" fill="#111111"/></svg>',
    use: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M11.0948 8.82798C10.1274 8.82798 9.16067 8.98748 8.1945 9.30648C7.22834 9.62548 6.33925 10.0737 5.52725 10.6512L6.62125 20.4465H17.3838L18.5468 9.83398H17.4545C16.8378 9.83398 16.2632 9.78881 15.7305 9.69848C15.1978 9.60831 14.4809 9.43423 13.5798 9.17623C13.1643 9.06473 12.7533 8.97881 12.347 8.91848C11.9407 8.85814 11.5233 8.82798 11.0948 8.82798ZM5.32825 8.75773C6.17825 8.24039 7.10142 7.84406 8.09775 7.56873C9.09425 7.29339 10.0928 7.14739 11.0935 7.13073C11.6015 7.13073 12.1043 7.16506 12.602 7.23373C13.0997 7.30239 13.5774 7.40139 14.0353 7.53073C14.8914 7.76806 15.544 7.92739 15.993 8.00873C16.4418 8.09006 16.9207 8.13073 17.4295 8.13073H18.7458L19.2468 3.55398H4.75225L5.32825 8.75773ZM6.62125 22.1497C6.18809 22.1497 5.8065 22.0074 5.4765 21.7227C5.14667 21.4379 4.9605 21.0787 4.918 20.6452L3.074 3.95198C3.016 3.38281 3.17734 2.88931 3.558 2.47148C3.93867 2.05364 4.41142 1.84473 4.97625 1.84473H19.0228C19.5876 1.84473 20.0603 2.05364 20.441 2.47148C20.8217 2.88931 20.983 3.38281 20.925 3.95198L19.087 20.6452C19.0405 21.0787 18.8538 21.4379 18.5268 21.7227C18.1999 22.0074 17.8189 22.1497 17.3838 22.1497H6.62125ZM11.0945 20.4525H13.5815C14.4815 20.4525 15.197 20.4515 15.728 20.4495C16.259 20.4475 16.8109 20.4465 17.3838 20.4465H6.62125C6.89842 20.4465 7.47134 20.4475 8.34 20.4495C9.20867 20.4515 10.1268 20.4525 11.0945 20.4525Z" fill="#111111"/></svg>',
    shipping: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h11v10H3V7zM14 10h4l3 3v4h-7V10z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="18" r="1.5" fill="currentColor"/><circle cx="18" cy="18" r="1.5" fill="currentColor"/></svg>',
    default: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  };

  const CHEVRON =
    '<svg class="product-metafield-accordions__chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function iconForTitle(title) {
    const t = (title || '').toLowerCase();
    if (t.includes('formula') || t.includes('serve') || t.includes('ingredient')) return ICONS.formula;
    if (t.includes('expect') || t.includes('benefit') || t.includes('result')) return ICONS.expect;
    if (t.includes('how to') || t.includes('use') || t.includes('direction')) return ICONS.use;
    if (t.includes('shipping') || t.includes('return') || t.includes('delivery')) return ICONS.shipping;
    if (t.includes('detail') || t.includes('about') || t.includes('description')) return ICONS.details;
    return ICONS.default;
  }

  function isHeading(el) {
    if (!el || el.nodeType !== 1) return false;
    const tag = el.tagName;
    return tag === 'H2' || tag === 'H3' || tag === 'H4';
  }

  function enhanceSummary(summary, titleText) {
    summary.className = 'product-metafield-accordions__summary';
    summary.innerHTML = '';

    const icon = document.createElement('span');
    icon.className = 'product-metafield-accordions__icon';
    icon.innerHTML = iconForTitle(titleText);

    const title = document.createElement('span');
    title.className = 'product-metafield-accordions__title';
    title.textContent = titleText;

    const chevronWrap = document.createElement('span');
    chevronWrap.className = 'product-metafield-accordions__chevron-wrap';
    chevronWrap.innerHTML = CHEVRON;

    summary.append(icon, title, chevronWrap);
  }

  function getContentRoot(raw) {
    const nested = raw.querySelector(
      '.metafield-rich_text_field, .rte, [class*="metafield-rich"], div'
    );
    if (nested && nested !== raw && raw.contains(nested) && nested.querySelector('h2, h3, h4')) {
      return nested;
    }
    return raw;
  }

  function siblingsUntilNextHeading(startEl) {
    const nodes = [];
    let sib = startEl.nextElementSibling;
    while (sib && !isHeading(sib)) {
      nodes.push(sib.cloneNode(true));
      sib = sib.nextElementSibling;
    }
    return nodes;
  }

  function buildFromDetails(raw, list, openFirst) {
    const details = [...raw.querySelectorAll('details')].filter((el) => raw.contains(el));
    if (!details.length) return false;

    details.forEach((detail, index) => {
      const titleText = detail.querySelector('summary')?.textContent?.trim() || `Section ${index + 1}`;
      const item = detail.cloneNode(true);
      item.className = 'product-metafield-accordions__item';
      if (openFirst && index === 0) item.setAttribute('open', '');

      const summary = item.querySelector('summary');
      if (summary) enhanceSummary(summary, titleText);

      const panel = document.createElement('div');
      panel.className = 'product-metafield-accordions__panel';
      const inner = document.createElement('div');
      inner.className = 'product-metafield-accordions__panel-inner rich__text-mt-0';
      [...item.childNodes].forEach((node) => {
        if (node.nodeName !== 'SUMMARY') inner.append(node);
      });
      panel.append(inner);
      item.querySelectorAll(':scope > :not(summary)').forEach((n) => n.remove());
      item.append(panel);

      list.append(item);
    });

    return true;
  }

  function buildFromHeadings(raw, list, openFirst) {
    const root = getContentRoot(raw);
    const headings = [...root.querySelectorAll('h2, h3, h4')];
    if (!headings.length) return false;

    const sections = [];

    const preHeadingNodes = [];
    let el = root.firstElementChild;
    while (el && el !== headings[0]) {
      if (!isHeading(el)) preHeadingNodes.push(el.cloneNode(true));
      el = el.nextElementSibling;
    }

    headings.forEach((heading, index) => {
      const nodes = siblingsUntilNextHeading(heading);
      if (index === 0 && preHeadingNodes.length) {
        nodes.unshift(...preHeadingNodes);
      }
      sections.push({
        title: heading.textContent.trim() || `Section ${index + 1}`,
        nodes,
      });
    });

    if (!sections.length) return false;

    sections.forEach((section, index) => {
      const item = document.createElement('details');
      item.className = 'product-metafield-accordions__item';
      if (openFirst && index === 0) item.setAttribute('open', '');

      const summary = document.createElement('summary');
      summary.className = 'product-metafield-accordions__summary';

      const icon = document.createElement('span');
      icon.className = 'product-metafield-accordions__icon';
      icon.innerHTML = iconForTitle(section.title);

      const title = document.createElement('span');
      title.className = 'product-metafield-accordions__title';
      title.textContent = section.title;

      summary.append(icon, title);
      const chevronWrap = document.createElement('span');
      chevronWrap.className = 'product-metafield-accordions__chevron-wrap';
      chevronWrap.innerHTML = CHEVRON;
      summary.append(chevronWrap);

      const body = document.createElement('div');
      body.className = 'product-metafield-accordions__panel';
      const inner = document.createElement('div');
      inner.className = 'product-metafield-accordions__panel-inner rich__text-mt-0';
      section.nodes.forEach((n) => inner.append(n));
      body.append(inner);

      item.append(summary, body);
      list.append(item);
    });

    return true;
  }

  function initContainer(container) {
    if (!container || container.dataset.accordionsBuilt === 'true') return;

    const raw = container.querySelector('.product-metafield-accordions__raw');
    const list = container.querySelector('.product-metafield-accordions__list');
    if (!raw || !list) return;

    const openFirst = container.dataset.accordionsOpenFirst === 'true';
    let built = buildFromDetails(raw, list, openFirst);
    if (!built) built = buildFromHeadings(raw, list, openFirst);

    if (!built && raw.innerHTML.trim()) {
      const item = document.createElement('details');
      item.className = 'product-metafield-accordions__item';
      if (openFirst) item.setAttribute('open', '');

      const summary = document.createElement('summary');
      summary.className = 'product-metafield-accordions__summary';
      const icon = document.createElement('span');
      icon.className = 'product-metafield-accordions__icon';
      icon.innerHTML = ICONS.details;
      const title = document.createElement('span');
      title.className = 'product-metafield-accordions__title';
      title.textContent = 'Product Details';
      summary.append(icon, title);
      const chevronWrap = document.createElement('span');
      chevronWrap.className = 'product-metafield-accordions__chevron-wrap';
      chevronWrap.innerHTML = CHEVRON;
      summary.append(chevronWrap);

      const body = document.createElement('div');
      body.className = 'product-metafield-accordions__panel';
      const inner = document.createElement('div');
      inner.className = 'product-metafield-accordions__panel-inner rich__text-mt-0';
      inner.innerHTML = raw.innerHTML;
      body.append(inner);
      item.append(summary, body);
      list.append(item);
    }

    container.dataset.accordionsBuilt = 'true';
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.product-metafield-accordions:not([data-accordions-built="true"])')
      .forEach(initContainer);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
